export enum CALENDERMODE{
    DAY = 'dates.timeUnits.day',
    WEEK = 'dates.timeUnits.week',
    MONTH = 'dates.timeUnits.month',
    YEAR = 'dates.timeUnits.year',
    
  }